const landing_page = {
  aboutUs: "About Us",
  topPackages: "Top Packages",
  featuredHotels: "Featured Hotels",
  topTours: "Top Tours",
  whatOurMembersSay: "What our members say...",
  followUsOnInstagram: "Follow us on Instagram",
  pleaseWait: "Please wait...",
  packages: "Packages",
  ourPartners: "Our Partners",
  trustedCarHirePartners: "Trusted Car Hire Partners",
  learnMore: "Learn More",
};

export default landing_page;
